let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 解锁关卡 https://yapi.aixuexi.com/project/42/interface/api/197345
  courseWareUnlock: `${baseUrl}/course/courseware/unlock`,
  // 备课配置查询 https://yapi.aixuexi.com/project/42/interface/api/197315
  courseWareInfo: `${baseUrl}/course/prepare/courseware/info`,
  // 授课-开始授课/结束授课 https://yapi.aixuexi.com/project/42/interface/api/197357
  courseWareStartEnd: (id, status) => `${baseUrl}/course/courseware/teaching/${id}/${status}`,
  // 授课控制一键暂停/一键开始 https://yapi.aixuexi.com/project/42/interface/api/197354
  courseWarePlayPause: (id, status) => `${baseUrl}/course/courseware/playstate/${id}/${status}`,
  // 授课-推送片段 https://yapi.aixuexi.com/project/42/interface/api/197351
  lessonPush: `${baseUrl}/lessonpush/send`,
  // 授课-当前播放进度（人数） https://yapi.aixuexi.com/project/42/interface/api/197360
  lessonPushNumber: `${baseUrl}/lessonpush/video`

}
